import { Card } from "@mui/material";
import CalendarByDoctor from "../../components/Chief/CalendarByDoctor";

export default function ScheduleByType(props) {
  return (
    <>
      <Card
        sx={{
          borderRadius: "4px",
        }}
      >
        <CalendarByDoctor />
      </Card>
    </>
  );
}
